import { useSearchResultsPageContext } from '../SearchResults/contexts/SearchResultsPageContext';
import ByStyleCategoryCarousel from './ByStyleCategoryCarousel';

export const ByStyleCategoryCarouselForSRP = ({ className }: { className?: string }) => {
  const { vendorSearch } = useSearchResultsPageContext();
  const { selectedLocation, selectedTaxonomy, selectedFacets } = vendorSearch;
  const showOnStateSRP = selectedLocation?.type === 'STATE' && selectedTaxonomy && !selectedFacets;
  const showOnCitySRP = selectedLocation?.type === 'CITY' && !selectedTaxonomy && !selectedFacets;

  if (!showOnStateSRP && !showOnCitySRP) {
    return null;
  }

  return <ByStyleCategoryCarousel className={className} location={selectedLocation} hideCta />;
};
